import React from "react";
import { TableHeader } from "../../../commons";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { LeaveAndUpcomingHistoryListType } from "../../../../redux/stcoTools/stcoToolsType";
import { currentDate, reverseDate } from "../../../../utils/commonFunctions";
import LeavePendingApprovalTableData from "./LeaveApprovedTableData";
import LeaveApprovedTableData from "./LeaveApprovedTableData";

type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | LeaveAndUpcomingHistoryListType[];
  openDrawer: () => void;
  setSingleLeaveId: React.Dispatch<React.SetStateAction<string>>;
};
const LeavesApprovedTable = ({
  tableHeader,
  data,
  openDrawer,
  setSingleLeaveId,
}: AppProps) => {
  return (
    <div className="jobsType" style={{ overflow: "auto" }}>
      <p style={{ fontSize: "18px", fontWeight: 600 }} className="p-3 m-0">
        Approved Leaves
      </p>
      <table className="table thead-light">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader tableHeader={tableHeader} />
        </thead>
        <tbody>
          <LeaveApprovedTableData
            openDrawer={openDrawer}
            tableHeader={tableHeader}
            data={data}
            setSingleLeaveId={setSingleLeaveId}
          />
        </tbody>
      </table>
    </div>
  );
};

export default LeavesApprovedTable;
